import { render, staticRenderFns } from "./sso-login.vue?vue&type=template&id=0d6a0b75"
import script from "./sso-login.vue?vue&type=script&lang=js"
export * from "./sso-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports